import React from 'react'
import { Tabs } from 'antd'
import startCase from 'lodash/startCase'
import { GetVerticals } from '@utils/verticals'

type Props = {
  activeTab: string
  onTabChange: (tab: string) => void
}

const RateSetTabs: React.FC<Props> = ({ activeTab, onTabChange }) => {
  const verticals = GetVerticals(true)

  return (
    <Tabs
      activeKey={activeTab}
      onChange={onTabChange}
      items={verticals.map(vertical => ({
        label: startCase(vertical.name),
        key: vertical.id
      }))}
    />
  )
}

export default RateSetTabs
